import { render, staticRenderFns } from "./PesquisaLocal copy.vue?vue&type=template&id=981da71e&"
import script from "./PesquisaLocal copy.vue?vue&type=script&lang=js&"
export * from "./PesquisaLocal copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports